<template>
  <div style="height: 100%">
    <div class="ef-node-form">
      <div class="ef-node-form-header">编辑</div>
      <div class="ef-node-form-body">
        <el-form
          :model="node"
          ref="dataForm"
          label-width="80px"
          v-show="type === 'node'"
        >
          <el-form-item label="名称">
            <el-input
              v-model="node.process_name"
              :disabled="node.type === 'is_end'"
            ></el-input>
          </el-form-item>
          <el-form-item label="left坐标" style="display: none">
            <el-input v-model="node.left" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="top坐标" style="display: none">
            <el-input v-model="node.top" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item
            label="审批场景"
            v-if="node.type !== 'repeat_send' && node.type !== 'is_judge' && node.type !== 'is_end'"
          >
            <el-select v-model="node.flow_app">
              <el-option label="经销商" value="agency"></el-option>
              <el-option label="内部审批" value="company"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="人员类型"
            v-if="node.type !== 'is_judge' && node.type !== 'is_end'"
          >
            <el-select v-model="node.auto_person">
              <el-option label="指定人员" :value="1"></el-option>
              <el-option label="指定角色" :value="2"></el-option>
              <el-option label="业务关联人员" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="
              node.type !== 'is_judge' &&
              node.type !== 'is_end' &&
              node.auto_person === 1
            "
            label="指定人员"
          >
            <el-input
              :value="node.user_text"
              readonly
              @click.native="selectUser"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="
              node.type !== 'is_judge' &&
              node.type !== 'is_end' &&
              node.auto_person === 2
            "
            label="指定角色"
          >
            <el-input
              :value="node.role_text"
              readonly
              @click.native="selectRole"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="
              node.type !== 'is_judge' &&
              node.type !== 'is_end' &&
              node.auto_person === 3
            "
            label="指定人员"
          >
            <el-select :value="node.work_id.length > 0 ? node.work_id.split(',') : []" @change="workIdChange" multiple>
              <el-option
                v-for="item of flow.options_bill_persons"
                :key="item.field"
                :label="item.name"
                :value="item.field"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="回退方式"
            v-if="node.type !== 'repeat_send' && node.type !== 'is_judge' && node.type !== 'is_end'"
          >
            <el-select v-model="node.is_back">
              <el-option label="允许回退" :value="1"></el-option>
              <el-option label="禁止回退" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="步骤类型"
            v-if="node.type !== 'repeat_send' && node.type !== 'is_judge' && node.type !== 'is_end'"
          >
            <el-select v-model="node.wf_mode">
              <el-option label="直线" :value="1"></el-option>
              <el-option label="流转" :value="2"></el-option>
              <el-option label="同步" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="操作"
            v-if="node.type !== 'repeat_send' && node.type !== 'is_judge' && node.type !== 'is_end'"
          >
            <el-input v-model="node.wf_action"></el-input>
          </el-form-item>
          <el-form-item
            label="节点"
            v-if="node.type !== 'repeat_send' && node.type !== 'is_judge' && node.type !== 'is_end'"
          >
            <el-input v-model="node.node_name"></el-input>
          </el-form-item>
          <el-form-item
            label="可否废单"
            v-if="node.type !== 'repeat_send' && node.type !== 'is_judge' && node.type !== 'is_end'"
          >
            <el-switch
              v-model="node.end_flow"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-close" @click="del">删除</el-button>
            <el-button type="primary" icon="el-icon-check" @click="save"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
        <el-form
          :model="line"
          ref="dataForm"
          label-width="80px"
          v-show="type === 'line'"
        >
          <el-form-item label="条件">
            <el-select v-model="line.condition" clearable>
              <el-option
                v-for="item of flow.options_condition"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-close" @click="del">删除</el-button>
            <el-button type="primary" icon="el-icon-check" @click="saveLine"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <transfer-dialog
      ref="transferDialogRole"
      @back="selectRoleHandler"
    ></transfer-dialog>
    <transfer-dialog
      ref="transferDialogStaff"
      @back="selectStaffHandler"
    ></transfer-dialog>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import transferDialog from "@/components/public/transfer-dialog.vue";

export default {
  components: {
    transferDialog,
  },
  props: {
    flow: {
      type: Object,
    },
  },
  data() {
    return {
      visible: true,
      // node 或 line
      type: "node",
      node: {},
      line: {},
      data: {},
    };
  },
  methods: {
    /**
     * 表单修改，这里可以根据传入的ID进行业务信息获取
     * @param data
     * @param id
     */
    nodeInit(data, id) {
      this.type = "node";
      this.data = data;
      data.nodeList.filter((node) => {
        if (node.id === id) {
          this.node = cloneDeep(node);
        }
      });
    },
    lineInit(line) {
      this.type = "line";
      this.line = line;
    },
    // 修改连线
    saveLine() {
      this.$emit(
        "setLineLabel",
        this.line.from,
        this.line.to,
        this.line.condition
      );
    },
    save() {
      if (!this.data.nodeList) {
        this.$message.error("请选择步骤");
        return;
      }
      this.data.nodeList.filter((node) => {
        if (node.id === this.node.id) {
          node.type = this.node.type;
          node.process_name = this.node.process_name;
          node.left = this.node.left;
          node.top = this.node.top;
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            node.type !== "repeat_send" &&
            (node.flow_app = this.node.flow_app);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            (node.auto_person = this.node.auto_person);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            (node.user_ids = this.node.user_ids);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            (node.user_text = this.node.user_text);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            (node.role_ids = this.node.role_ids);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            (node.role_text = this.node.role_text);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            (node.work_id = this.node.work_id);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            (node.work_text = this.node.work_text);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            node.type !== "repeat_send" &&
            (node.wf_mode = this.node.wf_mode);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            node.type !== "repeat_send" &&
            (node.is_back = this.node.is_back);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            node.type !== "repeat_send" &&
            (node.wf_action = this.node.wf_action);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            node.type !== "repeat_send" &&
            (node.node_name = this.node.node_name);
          this.node.type !== "is_judge" &&
            node.type !== "is_end" &&
            node.type !== "repeat_send" &&
            (node.end_flow = this.node.end_flow);
          this.$emit("repaintEverything", node);
        }
      });
    },
    del() {
      this.$emit("del");
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择角色(职位)
     */
    selectRole() {
      let arr = [];
      let keys = Object.keys(this.flow.options_role);
      for (let x in keys) {
        arr.push({
          label: this.flow.options_role[keys[x]],
          key: String(keys[x]),
        });
      }
      this.$refs.transferDialogRole.open(
        "选择角色",
        arr,
        this.node.role_ids.split(",")
      );
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择角色(职位)回调
     */
    selectRoleHandler(arr) {
      this.$set(this.node, "role_ids", arr.map((x) => x.key).join(","));
      this.$set(this.node, "role_text", arr.map((x) => x.label).join(","));
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择人员
     */
    selectUser() {
      this.$refs.transferDialogStaff.open(
        "选择人员",
        this.flow.options_user.map((x) => {
          return {
            label: x.realname,
            key: String(x.id),
          };
        }),
        this.node.user_ids.split(",")
      );
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择人员回调
     */
    selectStaffHandler(arr) {
      this.$set(this.node, "user_ids", arr.map((x) => x.key).join(","));
      this.$set(this.node, "user_text", arr.map((x) => x.label).join(","));
    },
    workIdChange(e) {
      this.$set(this.node, "work_id", e.join(","));
      this.$set(this.node, "work_text", this.flow.options_bill_persons.filter(x => e.includes(x.field)).map((x) => x.name).join(","));
      console.log(this.node)
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化选择
     */
    initSelect() {
      this.$set(this.node, "user_ids", "");
      this.$set(this.node, "user_text", "");
      this.$set(this.node, "role_ids", "");
      this.$set(this.node, "role_text", "");
      this.$set(this.node, "work_id", "");
      this.$set(this.node, "work_text", "");
    },
  },
};
</script>

<style>
.el-node-form-tag {
  position: absolute;
  top: 50%;
  margin-left: -15px;
  height: 40px;
  width: 15px;
  background-color: #fbfbfb;
  border: 1px solid rgb(220, 227, 232);
  border-right: none;
  z-index: 0;
}
</style>
